import React from "react";

export const TotalReachLogo = ({ size = 28, withText = true, className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`} data-testid="totalreach-logo">
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
      <defs>
        <linearGradient id="trg" x1="0" x2="1" y1="0" y2="1">
          <stop offset="0%" style={{ stopColor: "var(--brand-hex)" }} />
          <stop offset="100%" style={{ stopColor: "var(--brand2-hex)" }} />
        </linearGradient>
      </defs>
      <path d="M6 22 Q 6 14, 14 14" stroke="url(#trg)" strokeWidth="2.5" strokeLinecap="round" fill="none" />
      <path d="M6 22 Q 6 10, 18 10" stroke="url(#trg)" strokeWidth="2.5" strokeLinecap="round" fill="none" opacity="0.7" />
      <path d="M6 22 Q 6 6, 22 6" stroke="url(#trg)" strokeWidth="2.5" strokeLinecap="round" fill="none" opacity="0.4" />
      <circle cx="6" cy="22" r="2.5" style={{ fill: "var(--brand-hex)" }} />
    </svg>
    {withText && (
      <span className="font-display font-bold text-lg tracking-tight">
        <span className="text-white">Total</span>
        <span className="brand-gradient">Reach</span>
      </span>
    )}
  </div>
);
